import react, { useState, useEffect } from 'react';
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { useNavigate, useLocation, useParams } from 'react-router-dom';
import { motion } from 'framer-motion';
import Product1 from '../Img/Product1.png'
import Product2 from '../Img/Product2.png'
import Product3 from '../Img/Product3.png'
import Product4 from '../Img/Product4.png'
import Product5 from '../Img/Product5.png'
import Product6 from '../Img/Product6.png'
import decryptCookieData from './Functions/decryptCookieData';
import { toast, ToastContainer } from 'react-toastify';

// const products = [
//     { id: 1, title: "Mystic Oud Perfume", discountPrice: 2499, originalPrice: 3999, image: Product1, category: "Perfume", link: "/product-single-page" },
//     { id: 2, title: "Divine Blossom Fragrance", discountPrice: 1899, originalPrice: 3299, image: Product2, category: "Perfume", link: "/product-single-page" },
//     { id: 3, title: "Ocean Breeze Cologne", discountPrice: 2199, originalPrice: 3599, image: Product3, category: "Perfume", link: "/product-single-page" },
//     { id: 4, title: "Amber Luxe Perfume", discountPrice: 2799, originalPrice: 4499, image: Product4, category: "Perfume", link: "/product-single-page" },
//     { id: 5, title: "Midnight Musk Eau de Parfum", discountPrice: 3099, originalPrice: 4999, image: Product5, category: "Perfume", link: "/product-single-page" },
//     { id: 6, title: "Vanilla Noir Perfume", discountPrice: 1999, originalPrice: 3499, image: Product6, category: "Perfume", link: "/product-single-page" },
//     { id: 7, title: "Floral Enchant Perfume", discountPrice: 2299, originalPrice: 3899, image: Product1, category: "Perfume", link: "/product-single-page" },
//     { id: 8, title: "Spice Royale Fragrance", discountPrice: 2699, originalPrice: 4399, image: Product2, category: "Perfume", link: "/product-single-page" }
// ];

const ITEMS_PER_PAGE = 9;

const CategoryDetails = ({ cartItemsLength, setCartItemLength, fetchCart, cartButtons }) => {
    const [selectedOption, setSelectedOption] = useState("Best Selling");
    const [selectedCategories, setSelectedCategories] = useState([]);
    const [selectedPrice, setSelectedPrice] = useState([]);
    const [searchTerm, setSearchTerm] = useState("");
    const options = ["Best Selling", "Price: Low to High", "Price: High to Low", "Newest Arrivals"];
    const categories = ["Perfume", "Eau de Parfum", "Eau de Toilette", "Luxury", "Unisex", "Woody", "Floral", "Fresh", "Oriental"];
    const priceRanges = ["₹0 - ₹200", "₹200 - ₹400", "₹400 - ₹6000"];
    const navigate = useNavigate();
    const [currentPage, setCurrentPage] = useState(1);
    const [filteredProducts, setFilteredProducts] = useState([]);
    const [loadingMore, setLoadingMore] = useState(false);
    const [products, setProducts] = useState([])
    const userData = JSON.parse(localStorage.getItem("2xgxgshdugyywerw12gh")) || null; // Decrypt cookie data
    const isLoggedIn = !!userData?.user_id;
    const [variationModalData, setVariationModalData] = useState(null); // for Variable Products
    const [selectedTypes, setSelectedTypes] = useState([]); // ["Simple Product", "Variable Product", "Grouped Product"]
    const location = useLocation();
    const url = process.env.REACT_APP_API_URL

    const { name } = useParams();

    const handleProductClick = (id, name) => {
        // navigate(`/product/${name}/${id}`);
        const encryptedName = btoa(encodeURIComponent(name));
        const encryptedId = btoa(encodeURIComponent(id));

        navigate(`/product/${encryptedName}/${encryptedId}`);



    };

    const toggleCategory = (category) => {
        setSelectedCategories((prev) =>
            prev.includes(category) ? prev.filter((c) => c !== category) : [...prev, category]
        );
    };

    const togglePrice = (priceRange) => {
        setSelectedPrice((prev) =>
            prev.includes(priceRange) ? prev.filter((p) => p !== priceRange) : [...prev, priceRange]
        );
    };


    const getDefaultCartButton = () => {
        const isGetQuoteDefault = cartButtons.find(b => b.button_id === 'getquote' && b.default);
        if (isGetQuoteDefault) return 'getquote';

        const isAddToCartDefault = cartButtons.find(b => b.button_id === 'addtocart' && b.default);
        if (isAddToCartDefault) return 'addtocart';

        const isBuyNowDefault = cartButtons.find(b => b.button_id === 'buynow' && b.default);
        if (isBuyNowDefault) return 'buynow';

        return null; // fallback
    };
    const defaultButton = getDefaultCartButton();

    useEffect(() => {
        const newFilteredProducts = products
            .filter(product =>
                selectedCategories.length === 0 || selectedCategories.includes(product.category)
            )
            .filter(product => {
                if (selectedPrice.length === 0) return true;

                const priceToCompare = product.product_type === "Variable Product"
                    ? Math.min(...product.variation.map(v => Number(v.salePrice || v.price)))
                    : product.discountPrice;

                return selectedPrice.some(range => {
                    const [min, max] = range.replaceAll("₹", "").split(" - ").map(num => Number(num.trim()));
                    return priceToCompare >= min && priceToCompare <= max;
                });
            })
            .filter(product => {
                return selectedTypes.length === 0 || selectedTypes.includes(product.product_type);
            })
            .filter(product => {
                return !searchTerm || product.title.toLowerCase().includes(searchTerm.toLowerCase());
            }).sort((a, b) => {
                const getPrice = (product) => {
                    if (product.product_type === "Variable Product") {
                        return Math.min(...product.variation.map(v => Number(v.salePrice || v.price)));
                    }
                    return product.discountPrice;
                };

                if (selectedOption === "Price: Low to High") return getPrice(a) - getPrice(b);
                if (selectedOption === "Price: High to Low") return getPrice(b) - getPrice(a);
                if (selectedOption === "Newest Arrivals") return new Date(b.createdAt) - new Date(a.createdAt);
                return 0;
            });

        // ✅ Set the sorted/filtered list
        setFilteredProducts(newFilteredProducts);

        // ✅ Reset page to 1 after filters change
        if (currentPage !== 1) {
            setCurrentPage(1);
        }

    }, [products, selectedCategories, selectedPrice, selectedOption, selectedTypes, searchTerm]);


    // Dependencies to trigger re-filtering

    // Search filter (if needed)
    const filteredCategories = categories.filter(category =>
        category.toLowerCase().includes(searchTerm.toLowerCase())
    );

    const handleLoadMore = () => {
        setLoadingMore(true);
        setTimeout(() => {
            setCurrentPage(currentPage + 1);
            setLoadingMore(false);
        }, 1000); // Simulating API loading delay
    };

    const totalPages = Math.ceil(filteredProducts.length / ITEMS_PER_PAGE);
    // const indexOfLastProduct = currentPage * ITEMS_PER_PAGE;
    // const filterProduct = filteredProducts.slice(0, currentPage * ITEMS_PER_PAGE);
    const visibleProducts = filteredProducts.slice(
        0,
        Math.min(currentPage * ITEMS_PER_PAGE, filteredProducts.length)
    );





    const [modalType, setModalType] = useState(null);
    const openModal = (type) => setModalType(type);
    const closeModal = () => setModalType(null);

    const handleClearFilters = () => {
        setSelectedCategories([]);
        setSelectedPrice([]);
        setSearchTerm("");
        closeModal();
    };


    const handleApplyFilters = () => {
        closeModal();
    };



    const fetchProducts = async () => {
        try {
            const response = await fetch(`${url}/grouped-product/search-all-products/${process.env.REACT_APP_PERFUME_ID}`, {
                method: "GET"
            });
            const res = await response.json();

            const safeParse = (value) => {
                try {
                    return typeof value === "string" ? JSON.parse(value) : value || [];
                } catch (e) {
                    return [];
                }
            };

            const parsedProducts = res.map(product => ({
                ...product,
                gallery: safeParse(product.gallery),
                key_features: safeParse(product.key_features),
                specifications: safeParse(product.specifications),
                variation: safeParse(product.variation),
                attribute: safeParse(product.attribute),
            }));

            const matchedProducts = parsedProducts.filter(
                product => product.category?.toLowerCase() === name?.toLowerCase()
            );

            setProducts(matchedProducts);


        } catch (error) {
            console.error("❌ Error fetching products:", error);
        }
    };



    const handleAddToCart = async (productId) => {
        const res = await fetch(`${url}/grouped-product/single/${productId}`);
        const latestProduct = await res.json();

        if (latestProduct.product_type === "Variable Product") {
            const safeVariation = typeof latestProduct.variation === "string"
                ? JSON.parse(latestProduct.variation)
                : latestProduct.variation || [];

            setVariationModalData({ ...latestProduct, variation: safeVariation });
        } else {
            addProductToCart(latestProduct, latestProduct);
        }

    };


    const syncCartItemsWithLatestProducts = async () => {
        const cartItems = JSON.parse(localStorage.getItem('guest_cart')) || [];

        const updatedCart = await Promise.all(cartItems.map(async (item) => {
            try {
                const res = await fetch(`${url}/grouped-product/single/${item.product_id}`);
                const latest = await res.json();

                return {
                    ...item,
                    product_id: latest.product_id,
                    product_name: latest.title,
                    product_price: latest.originalPrice,
                    product_saleprice: latest.discountPrice,
                    product_stockstatus: latest.stock,
                    product_status: latest.status,
                    product_image: latest.image,
                    product_gallery: latest.gallery || [],
                };
            } catch (e) {
                console.error("Sync error:", e);
                return item;
            }
        }));

        localStorage.setItem('guest_cart', JSON.stringify(updatedCart));
    };

    const addProductToCart = async (variation, baseProduct = null) => {
        const item = {
            product_id: variation.product_id || baseProduct?.product_id,
            product_sku: variation.sku || baseProduct?.sku,
            product_name: baseProduct?.title || variation.title,
            product_price: variation.price || baseProduct?.originalPrice,
            product_saleprice: variation.salePrice || baseProduct?.discountPrice,
            product_stockstatus: variation.stock || baseProduct?.stock,
            product_status: baseProduct?.status || 'Active',
            product_image: variation.imageUrl || baseProduct?.image,
            product_gallery: baseProduct?.gallery || [],
            description: baseProduct?.description || "",
            short_description: baseProduct?.short_description || "",
            category: baseProduct?.category || "",
            product_type: baseProduct.product_type,
            variation_attributes: variation.attributes || {},
            typeofsimple: '',
            user_id: userData?.user_id || null,
            user_name: userData?.name || null,
            delivery_days: baseProduct.delivery_days || "",
            main_id: process.env.REACT_APP_PERFUME_ID,
        };

        if (isLoggedIn) {
            try {
                const response = await fetch(`${url}/cart`, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify(item),
                });

                const result = await response.json();

                if (!response.ok || result.isError) {
                    toast.warn(result.msg || "Product already in cart");
                    return false;
                } else {
                    await fetchCart(userData?.user_id);
                    toast.success("Added to cart");
                    return true;
                }
            } catch (error) {
                console.error("Add to cart error:", error);
                toast.error("Something went wrong");
            }
        } else {
            const existing = JSON.parse(localStorage.getItem('guest_cart')) || [];
            if (existing.some(p => p.sku === item.product_sku)) {
                toast.warn("Product already in cart");
                return false;
            }
            const updatedCart = [...existing, item];
            localStorage.setItem('guest_cart', JSON.stringify(updatedCart));
            toast.success("Added to cart");
            setCartItemLength(updatedCart.length);
            return true;
        }
    };

    useEffect(() => {
        syncCartItemsWithLatestProducts();
        fetchProducts();

        // Set initial search term from URL

    }, []);

    useEffect(() => {
        const queryParams = new URLSearchParams(location.search);
        const searchParam = queryParams.get("search");
        setSearchTerm(searchParam || ""); // update when URL changes
    }, [location.search]);



    return (
        <>
            <ToastContainer position="top-center" autoClose={3000} />
            <div className="shop-page">
                <div className="section-heading-perfume">
                    <h2>{name}</h2>
                </div>
                <div className="shop-filter-perfume">
                    <div className="shop-filter-perfume-container">
                        <div
                            className="shop-filter-perfume-title"
                            onClick={() => openModal("sort")}
                        >
                            Sort by <i className="fa-solid fa-chevron-down"></i>
                        </div>
                        {/* <div
                            className="shop-filter-perfume-title"
                            onClick={() => openModal("categories")}
                        >
                            Categories <i className="fa-solid fa-chevron-down"></i>
                        </div> */}
                        <div
                            className="shop-filter-perfume-title"
                            onClick={() => openModal("price")}
                        >
                            Price <i className="fa-solid fa-chevron-down"></i>
                        </div>

                    </div>


                    {/* Modals */}
                    {modalType === "sort" &&
                        <SortByModal
                            closeModal={closeModal}
                            selectedOption={selectedOption}
                            setSelectedOption={setSelectedOption}
                            options={options}
                            handleApplyFilters={handleApplyFilters}
                            handleClearFilters={handleClearFilters}
                        />}
                    {modalType === "categories" &&
                        <CategoriesModal
                            closeModal={closeModal}
                            selectedCategories={selectedCategories}
                            setSelectedCategories={setSelectedCategories}
                            categories={filteredCategories} // ✅ Use filteredCategories here
                            toggleCategory={toggleCategory}
                            handleApplyFilters={handleApplyFilters}
                            handleClearFilters={handleClearFilters}
                            searchTerm={searchTerm}
                            setSearchTerm={setSearchTerm}
                        />
                    }
                    {modalType === "price" &&
                        <PriceModal
                            closeModal={closeModal}
                            selectedPrice={selectedPrice}
                            setSelectedPrice={setSelectedPrice}
                            priceRanges={priceRanges}
                            togglePrice={togglePrice}
                            handleApplyFilters={handleApplyFilters}
                            handleClearFilters={handleClearFilters}
                        />}
                </div>
                <div className="new-arrival shop-page-perfume">
                    <div className="products">
                        {visibleProducts.length > 0 ? (
                            <>
                                {visibleProducts.map((product, index) => (
                                    <motion.div
                                        key={product.product_id || product.id}

                                        className="product-card"
                                        initial={{ opacity: 0, scale: 0.9 }}
                                        animate={{ opacity: 1, scale: 1 }}
                                        transition={{ delay: index * 0.2, duration: 0.6 }}
                                    // onClick={() => handleProductClick(product.product_id, product.title)}
                                    >
                                        <div className="product-img-wrapper">
                                            <img onClick={() => handleProductClick(product.product_id, product.title)} src={`${url}${product.image}`} alt={product.title} className="product-img" />

                                            {/* Overlay on Hover */}
                                            <div className="overlay">
                                                {defaultButton === 'addtocart' && (
                                                    <button className="add-to-cart" onClick={() => handleAddToCart(product.product_id)}><i className="fas fa-shopping-cart" /> Add to Cart</button>
                                                )}
                                                {defaultButton === 'buynow' && (
                                                    <button className="add-to-cart" ><i className="fas fa-bolt" />Buy Now</button>
                                                )}
                                                {defaultButton === 'getquote' && (
                                                    <button className="add-to-cart" onClick={() => handleProductClick(product.product_id, product.title)}><i className="fas fa-eye" />View</button>
                                                )}
                                            </div>
                                        </div>

                                        {/* Product Details */}
                                        <h3 className="product-title" onClick={() => handleProductClick(product.product_id, product.title)}>{product.title}</h3>
                                        <div className="product-pricing" onClick={() => handleProductClick(product.product_id, product.title)}>
                                            <div className="product-pricing">
                                                <span className="discount-price-card">
                                                    ₹{product.product_type === "Variable Product"
                                                        ? Math.min(...product.variation.map(v => Number(v.salePrice || v.price)))
                                                        : product.discountPrice}
                                                </span>
                                                <span className="original-price-card">
                                                    ₹{product.product_type === "Variable Product"
                                                        ? Math.min(...product.variation.map(v => Number(v.price)))
                                                        : product.originalPrice}
                                                </span>
                                            </div>

                                        </div>
                                        {defaultButton === 'addtocart' && (
                                            <div className="product-add-to-cardt-mobile"
                                                onClick={() => handleAddToCart(product.product_id)}
                                            >
                                                <button> <i style={{ marginRight: "5px" }} className="fas fa-shopping-cart"></i> Add to Cart</button>
                                            </div>
                                        )}
                                        {defaultButton === 'buynow' && (
                                            <div className="product-add-to-cardt-mobile"
                                            // onClick={() => handleAddToCart(product.product_id)}
                                            >
                                                <button> <i style={{ marginRight: "5px" }} className="fas fa-bolt"></i>Buy Now</button>
                                            </div>
                                        )}
                                        {defaultButton === 'getquote' && (
                                            <div className="product-add-to-cardt-mobile"
                                                // onClick={() => handleAddToCart(product.product_id)}
                                                onClick={() => handleProductClick(product.product_id, product.title)}
                                            >
                                                <button> <i style={{ marginRight: "5px" }} className="fas fa-eye"></i>View</button>
                                            </div>
                                        )}
                                    </motion.div>
                                ))}
                                {loadingMore && (
                                    [...Array(2)].map((_, index) => (
                                        <div key={`skeleton-${index}`} className="product-card">
                                            <div className="product-img-wrapper">
                                                <Skeleton height={150} />
                                            </div>
                                            <h3 className="product-title">
                                                <Skeleton width={100} />
                                            </h3>
                                            <div className="product-pricing">
                                                <Skeleton width={80} />
                                                <Skeleton width={60} />
                                            </div>
                                        </div>
                                    ))
                                )}
                                {currentPage < totalPages && visibleProducts.length >= ITEMS_PER_PAGE && (
                                    <div className="load-more-break">
                                        <br />
                                        <button className="load-more-btn-perfume" onClick={handleLoadMore}>Load More</button>
                                    </div>
                                )}

                            </>
                        ) : (
                            <p className="no-products">No products found</p>
                        )}
                    </div>
                </div>
            </div>
            {variationModalData && (
                <VariationModal
                    product={variationModalData}
                    onClose={() => setVariationModalData(null)}
                    onAddToCart={async (variation) => {
                        const success = await addProductToCart(variation, variationModalData);
                        if (success) {
                            setVariationModalData(null); // ✅ Only close if added
                        }
                    }}
                />

            )}

        </>
    );
};

export default CategoryDetails;

const ModalWrapper = ({ title, children, closeModal, handleApplyFilters, handleClearFilters }) => (
    <motion.div className="modal-overlay" onClick={closeModal}
        initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}>
        <motion.div className="modal-content" onClick={(e) => e.stopPropagation()}
            initial={{ y: -50, opacity: 0 }} animate={{ y: 0, opacity: 1 }} exit={{ y: -50, opacity: 0 }}>
            <div className="modal-heading-close">
                <h2 className="modal-heading">{title}</h2>
                <button className="modal-close-btn" onClick={closeModal}><i className="fa-solid fa-xmark"></i></button>
            </div>
            {children}
            <div className="modal-actions-btn">
                <button className="modal-clear-btn" onClick={handleClearFilters}>Clear</button>
                <button className="apply-btn" onClick={handleApplyFilters}>Apply</button>
            </div>
        </motion.div>
    </motion.div>
);

const SortByModal = ({
    closeModal,
    setSelectedOption,
    selectedOption,
    options,
    handleApplyFilters,
    handleClearFilters
}) => (
    <ModalWrapper
        title="Sort By"
        closeModal={closeModal}
        handleApplyFilters={handleApplyFilters}
        handleClearFilters={handleClearFilters}
    >
        <div className="modal-radio-group">
            {options.map((option, index) => (
                <label
                    key={index}
                    className={`radio-label ${selectedOption === option ? "selected" : ""}`}
                >
                    <input
                        type="radio"
                        name="sort"
                        value={option}
                        checked={selectedOption === option}
                        onChange={() => {
                            setSelectedOption(option);
                            handleApplyFilters(); // 👈 trigger apply right after selecting
                        }}

                    />
                    {option}
                </label>
            ))}
        </div>
    </ModalWrapper>
);


const CategoriesModal = ({ closeModal, selectedCategories, setSelectedCategories, categories, toggleCategory, handleApplyFilters, handleClearFilters, setSearchTerm, searchTerm }) => (
    <ModalWrapper title="Categories" closeModal={closeModal} handleApplyFilters={handleApplyFilters} handleClearFilters={handleClearFilters}>
        <input
            type="text"
            className="modal-search"
            placeholder="Search category..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
        />
        <div className="modal-checkboxes">
            {categories.map((category, index) => (
                <label key={index} className={`checkbox-label ${selectedCategories.includes(category) ? "checked" : ""}`}>
                    <input
                        type="checkbox"
                        value={category}
                        checked={selectedCategories.includes(category)}
                        onChange={() => toggleCategory(category)}
                    />
                    <div className="custom-checkbox-label">
                        <span className="custom-checkbox"></span>
                        <span className="checkbox-options">{category}</span>
                    </div>
                </label>
            ))}
        </div>
    </ModalWrapper>
);

const PriceModal = ({ closeModal, setSelectedPrice, selectedPrice, priceRanges, togglePrice, handleApplyFilters, handleClearFilters }) => (
    <ModalWrapper title="Price" closeModal={closeModal} handleApplyFilters={handleApplyFilters} handleClearFilters={handleClearFilters}>
        <div className="modal-checkboxes">
            {priceRanges.map((price, index) => (
                <label key={index} className={`checkbox-label ${selectedPrice.includes(price) ? "checked" : ""}`}>
                    <input
                        type="checkbox"
                        value={price}
                        checked={selectedPrice.includes(price)}
                        onChange={() => togglePrice(price)}
                        onApply={closeModal}
                        onClear={() => setSelectedPrice([])}
                    />
                    <div className="custom-checkbox-label">
                        <span className="custom-checkbox"></span>
                        <span className="checkbox-options">{price}</span>
                    </div>
                </label>
            ))}
        </div>
    </ModalWrapper>
);


const VariationModal = ({ product, onClose, onAddToCart }) => {
    const url = process.env.REACT_APP_API_URL
    return (
        <motion.div className="modal-overlay" initial={{ opacity: 0 }} animate={{ opacity: 1 }}>
            <motion.div className="variation-modal" initial={{ y: -50 }} animate={{ y: 0 }}>
                <div className="modal-header">
                    <h2>{product.title} - Choose a Variation</h2>
                    <button className="modal-close" onClick={onClose}><i className="fa fa-times" /></button>
                </div>

                <div className="variation-flex-container">
                    {(Array.isArray(product.variation) ? product.variation : []).map((v, idx) => (
                        <div key={idx} className="variation-flex-card">
                            <img src={`${url}${v.imageUrl}`} alt={v.sku} />
                            <div className="variation-info">
                                <p><strong>SKU:</strong> {v.sku}</p>
                                <p><strong>Price:</strong> ₹{v.price}</p>
                                {v.salePrice && <p><strong>Sale:</strong> ₹{v.salePrice}</p>}
                                <p><strong>Stock:</strong> {v.stock}</p>
                                <button onClick={() => onAddToCart(v)} className="add-cart-btn">
                                    Add to Cart
                                </button>
                            </div>
                        </div>
                    ))}
                </div>
            </motion.div>
        </motion.div>
    );
};

